import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import MoreReports from "./MoreReports";
import EssentialReportData from "./EssentialReportData";
const EssentialReports = (props) => {
    const [index, setIndex] = useState(0);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 essentialreport" },
            React.createElement(Col, { lg: 12, className: "px-0" },
                React.createElement("div", { className: "essentialreportgrid" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "mgt-50" },
                            React.createElement("span", { className: "DMSansMedium_18_500 txt-midnight-blue" }, "Essential Reports")),
                        React.createElement("div", { className: "leftsection-grid grid-4 gap-20 mgt-30" },
                            React.createElement(EssentialReportData, null))),
                    React.createElement("div", { className: "rightsection-grid" },
                        React.createElement(MoreReports, { setMoreReport: props.setMoreReport })))))));
};
export default EssentialReports;
